import { render, staticRenderFns } from "./DeptMerge.vue?vue&type=template&id=607dbefc&scoped=true&"
import script from "./DeptMerge.vue?vue&type=script&lang=js&"
export * from "./DeptMerge.vue?vue&type=script&lang=js&"
import style0 from "./DeptMerge.vue?vue&type=style&index=0&id=607dbefc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607dbefc",
  null
  
)

export default component.exports